import { render, staticRenderFns } from "./CostBearersEmailForm.vue?vue&type=template&id=597437ef&"
import script from "./CostBearersEmailForm.vue?vue&type=script&lang=ts&"
export * from "./CostBearersEmailForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports